import api from '../../plugins/api';

// POST /api/crm/onboarding â ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½Ð½Ð¾Ðµ. ÐÐ¾Ð¶Ð½Ð¾ ÑÐ»Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾,
// ÑÑÐ¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¾ÑÑ: Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ Ð¿Ð¾Ð»Ñ Ð½Ð° ÑÐµÑÐ²ÐµÑÐµ Ð¾ÑÑÐ°Ð½ÑÑÑÑ ÐºÐ°Ðº Ð±ÑÐ»Ð¸.
const saveOnboarding = ({ tourSeen, checklist, checklistHidden }) => {
  return api.post('/api/crm/onboarding', { tourSeen, checklist, checklistHidden });
};

export default saveOnboarding;
